"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rogueGenHouse = void 0;
var entitiesUtils_sidecar_1 = require("../../../entities/entitiesUtils-sidecar");
var rando_sidecar_1 = require("../../../lib/rando-sidecar");
var rogueMonofont_sidecar_1 = require("../monofont/rogueMonofont-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueTester_7drl_2023_sidecar_1 = require("../scene/rogueTester_7drl_2023-sidecar");
var rogueGlyphs_sidecar_1 = require("../targeting/rogueGlyphs-sidecar");
var rogueGenHouse_fire_sidecar_1 = require("./rogueGenHouse_fire-sidecar");
var rogueGenHouse_render_1 = require("./rogueGenHouse_render");
var rogueMaps_sidecar_1 = require("./rogueMaps-sidecar");
var _debug_slowmo = false;
function rogueGenHouse(house, houseGen, difficulty) {
    var w, h, delay, rooms, isRectInRange, doRectsIntersect, checkIfRoomIsValid, areRectsSame, testRect, tryAdjustRoom, debugDisplay, roomsValidPercentage, writeStatus, iAttempt, i, room, roomsClone, roomsAreValidCount, iterations, room, validPer, iCompress, room, longDelay, map, i, i, i;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                w = house.w;
                h = house.h;
                house.hp = house.maxHp;
                delay = 0.001;
                rooms = [];
                isRectInRange = function (r) {
                    if (r.x < 0 || r.y < 0 || r.x + r.w > w || r.y + r.h > h) {
                        return false;
                    }
                    return true;
                };
                doRectsIntersect = function (a, b) {
                    return (a.x <= b.x + b.w &&
                        b.x <= a.x + a.w &&
                        a.y <= b.y + b.h &&
                        b.y <= a.y + a.h);
                };
                checkIfRoomIsValid = function (room) {
                    if (room.w >= room.minW && room.h >= room.minW) {
                        if (room.w <= room.maxW && room.h <= room.maxW) {
                            room.isValid = true;
                            return true;
                        }
                    }
                    room.isValid = false;
                    return false;
                };
                areRectsSame = function (a, b) {
                    return a.x === b.x && a.y === b.y && a.w === b.w && a.h === b.h;
                };
                testRect = function (r, ignoreRoom) {
                    if (!isRectInRange(r)) {
                        return false;
                    }
                    for (var i = 0; i < rooms.length; i++) {
                        var testRoom = rooms[i];
                        if (areRectsSame(testRoom, ignoreRoom)) {
                            continue;
                        }
                        if (doRectsIntersect(r, testRoom)) {
                            checkIfRoomIsValid(ignoreRoom);
                            if (!ignoreRoom.isValid) {
                                testRoom.askToShrink++;
                            }
                            testRoom.askToMove++;
                            ignoreRoom.askToMove++;
                            return false;
                        }
                        // if (
                        //   r.x < room.x + room.w &&
                        //   r.x + r.w > room.x &&
                        //   r.y < room.y + room.h &&
                        //   r.y + r.h > room.y
                        // ) {
                        //   return false
                        // }
                    }
                    return true;
                };
                tryAdjustRoom = function (room, allowGrow, allowCenter, allowAdjust) {
                    if (allowGrow === void 0) { allowGrow = true; }
                    if (allowCenter === void 0) { allowCenter = true; }
                    if (allowAdjust === void 0) { allowAdjust = true; }
                    var directions = [-1, -2];
                    if (allowGrow) {
                        directions.push(1, 2, 3, 4);
                    }
                    if (allowCenter) {
                        directions.push(-1, -2);
                    }
                    if (allowAdjust) {
                        if (room.askToMove) {
                            directions.push(5, 6, 7, 8);
                        }
                        if (room.askToShrink) {
                            if (room.w > room.minW) {
                                directions.push(9, 11);
                            }
                            if (room.h > room.minW) {
                                directions.push(10, 12);
                            }
                        }
                    }
                    while (directions.length > 0) {
                        var isShrink = false;
                        var isMove = false;
                        var isGrow = false;
                        var newRect = { x: room.x, y: room.y, w: room.w, h: room.h };
                        var dir = rando_sidecar_1.rando.sampleAndRemove(directions);
                        // console.log('sampled dir', dir, directions)
                        if (dir === -1) {
                            // Move to center x
                            if (room.x + room.w / 2 < w / 2) {
                                newRect.x += 1;
                            }
                            else {
                                newRect.x -= 1;
                            }
                        }
                        if (dir === -2) {
                            // Move to center y
                            if (room.y + room.h / 2 < h / 2) {
                                newRect.y += 1;
                            }
                            else {
                                newRect.y -= 1;
                            }
                        }
                        if (dir === 1) {
                            newRect.x -= 1;
                            newRect.w += 1;
                            isGrow = true;
                        }
                        if (dir === 2) {
                            newRect.y -= 1;
                            newRect.h += 1;
                            isGrow = true;
                        }
                        if (dir === 3) {
                            newRect.w += 1;
                            isGrow = true;
                        }
                        if (dir === 4) {
                            newRect.h += 1;
                            isGrow = true;
                        }
                        // Move without growing
                        if (dir === 5) {
                            newRect.x -= 1;
                            isMove = true;
                        }
                        if (dir === 6) {
                            newRect.y -= 1;
                            isMove = true;
                        }
                        if (dir === 7) {
                            newRect.x += 1;
                            isMove = true;
                        }
                        if (dir === 8) {
                            newRect.y += 1;
                            isMove = true;
                        }
                        if (dir === 9) {
                            newRect.w -= 1;
                            room.askToShrink--;
                            isShrink = true;
                        }
                        if (dir === 10) {
                            newRect.h -= 1;
                            room.askToShrink--;
                            isShrink = true;
                        }
                        if (dir === 11) {
                            newRect.x -= 1;
                            newRect.w -= 1;
                            room.askToShrink--;
                            isShrink = true;
                        }
                        if (dir === 12) {
                            newRect.y -= 1;
                            newRect.h -= 1;
                            isShrink = true;
                        }
                        if (newRect.w <= 0 || newRect.h <= 0) {
                            continue;
                        }
                        if (newRect.w > room.maxW || newRect.h > room.maxW) {
                            continue;
                        }
                        if (testRect(newRect, room)) {
                            room.x = newRect.x;
                            room.y = newRect.y;
                            room.w = newRect.w;
                            room.h = newRect.h;
                            if (isMove && room.askToMove > 0) {
                                room.askToMove--;
                            }
                            if (isShrink && room.askToShrink > 0) {
                                room.askToShrink--;
                            }
                            return true;
                        }
                    }
                    return false;
                };
                debugDisplay = function (_de) {
                    if (_de === void 0) { _de = delay * 2; }
                    var x = 2;
                    var y = 2;
                    for (var i = 0; i < rooms.length; i++) {
                        var room = rooms[i];
                        for (var j = 0; j < room.h; j++) {
                            for (var i_1 = 0; i_1 < room.w; i_1++) {
                                rogueGlyphs_sidecar_1.rogueGlyphs.write(room.x + i_1 + x, room.y + j + y, '*', room.color, _de);
                            }
                        }
                        rogueMonofont_sidecar_1.rogueMonofont.write(room.x + x, room.y + y, room.abbreviation, _de);
                    }
                };
                roomsValidPercentage = function () {
                    var valid = 0;
                    for (var i = 0; i < rooms.length; i++) {
                        var roomCheck = rooms[i];
                        if (roomCheck.isValid) {
                            valid++;
                        }
                    }
                    return valid / (rooms.length || 1);
                };
                writeStatus = function (status) {
                    rogueMonofont_sidecar_1.rogueMonofont.write(1, 1, status, rogueDef_sidecar_1.rogueDef.colors.dark, rogueDef_sidecar_1.rogueDef.colors.light, null, null, null, '', delay);
                };
                iAttempt = 0;
                _a.label = 1;
            case 1:
                if (!(iAttempt < 100)) return [3 /*break*/, 13];
                writeStatus('Generating... ' + iAttempt);
                return [4 /*yield*/, { delay: delay }];
            case 2:
                _a.sent();
                rooms = house.makeRooms();
                i = 0;
                _a.label = 3;
            case 3:
                if (!(i < rooms.length)) return [3 /*break*/, 6];
                room = rooms[i];
                room.x = rando_sidecar_1.rando.i(1, w - 2);
                room.y = rando_sidecar_1.rando.i(1, h - 2);
                room.w = 1;
                room.h = 1;
                if (!_debug_slowmo) return [3 /*break*/, 5];
                debugDisplay();
                return [4 /*yield*/, { delay: delay }];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5:
                i++;
                return [3 /*break*/, 3];
            case 6:
                roomsClone = rooms.map(function (c) { return c; });
                roomsAreValidCount = 0;
                iterations = 0;
                _a.label = 7;
            case 7:
                if (!(roomsClone.length > 0)) return [3 /*break*/, 11];
                iterations++;
                if (iterations > 500) {
                    return [3 /*break*/, 11];
                }
                if (roomsAreValidCount > 10) {
                    return [3 /*break*/, 11];
                }
                room = rando_sidecar_1.rando.sample(roomsClone);
                if (!!tryAdjustRoom(room, true, true, true)) return [3 /*break*/, 8];
                // entitiesUtils.remove(roomsClone, room)
                checkIfRoomIsValid(room);
                room.stuckFor++;
                if (room.stuckFor > 10) {
                    if (!room.isValid) {
                        return [3 /*break*/, 11];
                    }
                    entitiesUtils_sidecar_1.entitiesUtils.remove(roomsClone, room);
                }
                return [3 /*break*/, 10];
            case 8:
                if (!_debug_slowmo) return [3 /*break*/, 10];
                debugDisplay();
                return [4 /*yield*/, { delay: delay }];
            case 9:
                _a.sent();
                _a.label = 10;
            case 10:
                validPer = roomsValidPercentage();
                console.log('valid?', validPer, roomsAreValidCount);
                if (validPer >= 1) {
                    roomsAreValidCount++;
                }
                return [3 /*break*/, 7];
            case 11:
                if (roomsValidPercentage() === 1) {
                    return [3 /*break*/, 13];
                }
                _a.label = 12;
            case 12:
                iAttempt++;
                return [3 /*break*/, 1];
            case 13:
                // Compress
                console.log('compressing');
                iCompress = 0;
                _a.label = 14;
            case 14:
                if (!(iCompress < 100)) return [3 /*break*/, 17];
                room = rando_sidecar_1.rando.sample(rooms);
                tryAdjustRoom(room, true, true, false);
                writeStatus('Compressing');
                if (!_debug_slowmo) return [3 /*break*/, 16];
                debugDisplay(delay);
                return [4 /*yield*/, { delay: delay }];
            case 15:
                _a.sent();
                _a.label = 16;
            case 16:
                iCompress++;
                return [3 /*break*/, 14];
            case 17:
                longDelay = 0.25;
                if (_debug_slowmo) {
                    longDelay = 2;
                }
                if (!_debug_slowmo) return [3 /*break*/, 19];
                debugDisplay(longDelay);
                return [4 /*yield*/, { delay: longDelay }];
            case 18:
                _a.sent();
                _a.label = 19;
            case 19:
                house.rooms = rooms;
                map = rogueMaps_sidecar_1.rogueMaps.getCurrentMap();
                if (!(0, rogueGenHouse_render_1.renderHouseToMap)(house, map)) {
                    console.log('bad map, restarting');
                    setTimeout(function () {
                        rogueTester_7drl_2023_sidecar_1.rogueTester_7drl_2023.nextLevel(false, true, difficulty, houseGen); // Start regen over
                    }, 1);
                }
                else {
                    console.log('good map!');
                    // TODO: add fire settings
                    for (i = 0; i < house.difficulty.numBigFires; i++) {
                        rogueGenHouse_fire_sidecar_1.rogueGenHouse_fire.addRandomFire(house, map);
                    }
                    for (i = 0; i < house.difficulty.numSmallFires; i++) {
                        rogueGenHouse_fire_sidecar_1.rogueGenHouse_fire.addRandomSmoke(house, map);
                    }
                    for (i = 0; i < house.difficulty.numPets; i++) {
                        rogueGenHouse_fire_sidecar_1.rogueGenHouse_fire.addRandomCatOrDog(house, map);
                    }
                }
                return [2 /*return*/];
        }
    });
}
exports.rogueGenHouse = rogueGenHouse;
